import { Injectable, Injector } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { ClassificacaoAgendamentoModel, ClassificacaoDto } from '../models';
import { SelectDto } from 'projects/ProjetoBaseAngular/domain/models/select-dto';

@Injectable({
  providedIn: 'root'
})
export class ClassificacaoAgendamentoService extends BaseCrudService<ClassificacaoAgendamentoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'ClassificacaoAgendamento';
  }

  getSelectList(): Observable<ClassificacaoDto[]> {
    return this
      .httpClient
      .get<ClassificacaoAgendamentoModel>(`${this.getApiUrl()}${this.getController()}/GetSelectList`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
